module.exports = __webpack_public_path__ + "img/microbialGarden.b97cb118.webp";